import PageviewIcon from '@mui/icons-material/Pageview';
import ModeIcon from '@mui/icons-material/Mode';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import PopUpJournal from './PopUpJournal';
import { GridActions, ActionPopup } from '../../../../components/datatable/GridActions';
import moment from 'moment';
// import PopUpEditJour from './PopUpEditJour';

export const columns = [
    { field: 'num', headerName: 'NO', width: 60 },
    {
        field: 'JournalCode',
        headerName: 'Journal Number',
    },
    {
        field: 'TransDate',
        headerName: 'TransDate',
        valueFormatter: (value) => value ? moment(value).format('DD/MM/YYYY') : '',
    },
    {
        field: 'CustID',
        headerName: 'CustID',
    },
    {
        field: 'CustName',
        maxWidth: 450,
        headerName: 'CustName',
    },
    {
        field: 'HeadItemName',
        maxWidth: 550,
        headerName: 'ชื่อสินค้า (หัวเอกสาร)',
    },
    {
        field: 'ItemID',
        headerName: 'ItemID',
    },
    {
        field: 'ItemName',
        maxWidth: 450,
        headerName: 'ItemName',
    },
    {
        field: 'action',
        headerName: 'action',
        width: 80,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
            return (
                <GridActions>
                    <ActionPopup tone="view"><PopUpJournal jourId={params.row.JournalHeadID} /></ActionPopup>
                </GridActions>
            )
        }
    }
];
